// extracted by mini-css-extract-plugin
export default {"notified-container":"notified-titles_notified-container__2R5cm","notified-direct-container":"notified-titles_notified-direct-container__rdbE7"};